import React from "react";
import { Typography } from "@mui/material";
import { generateTestId } from "app/functions";

const HotTypography = ({
  color = "#000",
  size,
  text,
  children,
  variant = "body1",
  component = "div",
  fontWeight,
  textAlign = "left",
  sx = {},
  testID = "hot-typography",
  ...rest
}) => {
  const content = children || text;

  return (
    <Typography
      variant={variant}
      component={component}
      testID={generateTestId(testID, "typography")}
      sx={{
        color: color,
        fontSize: size,
        fontWeight: fontWeight,
        textAlign: textAlign,
        margin: 0,
        padding: 0,
        "& p": {
          margin: 0,
          padding: 0,
          color: color,
        },
        ...sx,
      }}
      {...rest}
    >
      {content}
    </Typography>
  );
};

export default HotTypography;

